import resource from '../resource';

export const promoListApi = resource('/promotions/');
